import { type App, inject } from 'vue'

import type { InitialState } from '@/initial-state.ts'

const initialStateKey = 'app.state.initial'

export function installInitialState(
    app: App,
    initialState: InitialState
): void {
    app.provide(initialStateKey, initialState)
}

export function useInitialState(): InitialState {
    return inject(initialStateKey) as InitialState
}
